<template>
  {{ format }}
</template>

<script>
import {money} from "../../helpers/formatter"

export default {
  name: "Money",

  props: {
    value: Number,
  },

  computed: {
    format() {
      return this.value > 0 ? money(this.value) : '—'
    },
  }
}
</script>
